import { TestParserOptions } from "../../options/testParserOptions.js";
import { keywords } from "../keywords.js";

/**
 * Checks if a value has a custom title (via metadata or literal property).
 * 
 * @param value - The object or function to check.
 * @param options - Parser options.
 * @returns True if the value has a title defined.
 */
export function hasTitle(value: any, options: TestParserOptions): boolean {
  return Object.hasOwn(value, keywords.title)
    || (options.parserFlags!.allowLiteralTitle && Object.hasOwn(value, "title"))
}

/**
 * Retrieves the custom title from a value.
 * 
 * @param value - The object or function.
 * @param options - Parser options.
 * @returns The title string or boolean.
 */
export function getTitle(value: any, options: TestParserOptions): string | boolean {
  return value[keywords.title]
    || (options.parserFlags!.allowLiteralTitle && value["title"]);
}

/**
 * Checks if a value has a title defined specifically via a decorator.
 * 
 * @param value - The object or function.
 * @returns True if a title string is present in the keywords property.
 */
export function hasTitleDecorator(value: any): boolean {
  return typeof value[keywords.title] === 'string';
}
